<template>
  <button type="submit" @click="$emit('clicked')" class="dropdown-item px-4" v-if="as == 'button'">
    <slot></slot>
  </button>

  <inertia-link :href="href" :method="method" class="dropdown-item px-4" v-else>
    <slot></slot>
  </inertia-link>
</template>

<script>
export default {
  emits: ['clicked'],
  // props: ['href', 'as', 'method']
  props: {
      href: {
          type: String,
          default: '',
      },
      as: {
          type: String,
          default: 'a',
      },
      method: {
          type: String,
          default: 'get',
      }
  }
}
</script>
